import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="200"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path d="M2.10764 27.9999L0 25.8922L22.8923 2.99993H8.99993V0H27.9999V18.9999H24.9999V5.10757L2.10764 27.9999Z" fill="currentColor"/>
  </svg>
);

export default SvgIcon;
